import { goto } from '$app/navigation'
import { route } from '$lib/ROUTES'
import { UserRole } from '$lib/components/role/role'
import { tenantSettings } from '$lib/domain/tenantSettings/tenantSettings'
import { setRequestInterceptor } from '$lib/domain/userImpersonation/requestInterceptor'
import { nodeApi } from '$lib/settings'
import { initIntercomAdminLoggedIn, updateIntercomVisibility } from '../../../intercom'
import { $t } from '@repo/i18n'
import { ToastType } from '@repo/ui'
import { user } from '@repo/ui'
import { toasts } from '@repo/ui'
import { account, accountOrErrorCode, impersonatedAccount, originalAccount } from '@store/account'
import { isCurrentPage } from '@store/isCurrentPage'
import { tick } from 'svelte'
import { locale } from 'svelte-i18n'
import { get } from 'svelte/store'

export async function handleImpersonateAccount(accountId: string, name: string) {
	try {
		const response =
			await nodeApi.authenticationV1AuthenticationService.authenticationServiceGetAccount({
				headers: {
					'X-Impersonated-Account-Id': accountId,
				},
			})

		const accountToImpersonate = response.data.account

		if (
			get(isCurrentPage)(route('/affiliate/list'), true) ||
			get(isCurrentPage)(route('/affiliate-managers'), true) ||
			get(isCurrentPage)(route('/advertisers/list'), true)
		) {
			goto(route('/dashboard'))

			// wait to navigation before change the account
			await tick()
		}

		originalAccount.set(get(accountOrErrorCode))
		accountOrErrorCode.set(accountToImpersonate)
		impersonatedAccount.set({ accountId, name })
		updateIntercomVisibility(accountToImpersonate)

		setRequestInterceptor(accountId)
	} catch (_e) {
		impersonatedAccount.set(null)
		toasts.add({
			type: ToastType.error,
			title: $t('userImpersonation.impersonateError'),
			text: $t('userImpersonation.impersonateErrorDescription'),
		})
	}
}

export function handleImpersonateRevert() {
	const revertPage =
		get(account)?.role.name === UserRole.AffiliateManager
			? route('/affiliate-managers')
			: get(account)?.role.name === UserRole.Advertiser
				? route('/advertisers/list')
				: route('/affiliate/list')

	accountOrErrorCode.set(get(originalAccount))
	originalAccount.set(null)
	impersonatedAccount.set(null)

	setRequestInterceptor(null)
	initIntercomAdminLoggedIn(
		get(user),
		get(tenantSettings).tenantDetail.id,
		get(locale),
		get(tenantSettings),
	)
	updateIntercomVisibility(get(account))

	goto(revertPage)
}

export async function initAccountImpersonation() {
	const $impersonatedAccount = await impersonatedAccount.load()

	if ($impersonatedAccount?.accountId) {
		await handleImpersonateAccount($impersonatedAccount.accountId, $impersonatedAccount.name)
	}
}
